<template>
<confirm :bodyContent="bodyContent" :header="header" :callback="callback" :yes="yes" :no="no"></confirm>
</template>

<script>
import Confirmation from '../utils/Confirmation.vue'
export default {
  name: 'OrderConfirmation',
  props: ['bodyContent', 'header', 'callback', 'yes', 'no'],
  components: {
    confirm: Confirmation
  }
}
</script>

<style>
</style>
